import React, { FC, ReactNode } from 'react';
import { MessageDialog } from 'src/components/widgets/dialog';
import { T } from 'src/shared/helpers';

const ERROR_TITLE_STYLE = { color: '#d32f2f', marginBottom: '16px' } as const;
const TITLE_STYLE = { marginBottom: '16px' } as const;
const ERROR_DETAIL_STYLE = { marginTop: '8px', fontSize: '13px', color: '#d32f2f' } as const;
const CONTACT_STYLE = { marginTop: '16px' } as const;
const EMAIL_STYLE = { marginTop: '8px' } as const;

interface SwitchSupportDialogProps {
    title: string;
    /** Renders the title in the error colour. */
    isError?: boolean;
    intro: ReactNode;
    /** Only the failure variant has error text to show. */
    errorDetail?: string | null;
    onClose: () => void;
}

/** "Contact support" shell shared by the switch failure and the 2-hour polling timeout. */
const SwitchSupportDialog: FC<SwitchSupportDialogProps> = ({ title, isError, intro, errorDetail, onClose }) => (
    <MessageDialog
        showCloseButton={true}
        message={
            <>
                <h3 style={isError ? ERROR_TITLE_STYLE : TITLE_STYLE}>{title}</h3>
                <p>{intro}</p>
                {errorDetail && (
                    <p style={ERROR_DETAIL_STYLE}>
                        {T._('Error details:', 'Admin')} {errorDetail}
                    </p>
                )}
                <p style={CONTACT_STYLE}>{T._('Please contact the Zakeke support team for assistance:', 'Admin')}</p>
                <p style={EMAIL_STYLE}>
                    {T._('Email:', 'Admin')} <a href='mailto:support@zakeke.com'>support@zakeke.com</a>
                </p>
            </>
        }
        buttons={[
            {
                label: T._('Close', 'Admin'),
                onClick: onClose
            }
        ]}
    />
);

export default SwitchSupportDialog;
